import { useState } from "react";
import { Button, Modal, Collapse, Descriptions, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import usePdfBlob from "../../hooks/usePdfBlob";
import PdfPreviewer from "../PdfPreviewer";

const { Panel } = Collapse;

const ViewingFormButton = ({
  contents = {},
  viewingDataConfig = [],
  viewingType,
  viewingModalWidth = 800, // default width if not specified
  buttonText = "View Submission",
  isIcon = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const { pdfBlobUrl, loading } = usePdfBlob({
    endpoint: "/fsr/pdf/snapshot",
    params: {
      submission_id: contents.submission?.id,
    },
    enabled: viewingType === "pdf" && isOpen,
  });

  return (
    <>
      <Tooltip title={buttonText}>
        <Button
          shape={isIcon ? "circle" : undefined}
          icon={<EyeOutlined />}
          type="primary"
          //   style={{ backgroundColor: "#4286f5" }}
          onClick={openModal}
        >
          {isIcon ? null : buttonText}
        </Button>
      </Tooltip>

      <Modal
        open={isOpen}
        title="Submission Preview"
        footer={null}
        onCancel={closeModal}
        width={viewingModalWidth}
      >
        {viewingType === "pdf" ? (
          <PdfPreviewer
            pdfBlobUrl={pdfBlobUrl}
            loading={loading}
            height="65vh"
          />
        ) : (
          <Collapse defaultActiveKey={["1"]}>
            {viewingDataConfig.map(({ key, collapseName, collapseItems }) => (
              <Panel header={collapseName} key={key}>
                <Descriptions bordered column={1} size="small">
                  {collapseItems.map(({ name, label, render }) => (
                    <Descriptions.Item label={label} key={name}>
                      {render ? render(contents?.[name]) : (contents?.[name] || "-")}
                    </Descriptions.Item>
                  ))}
                </Descriptions>
              </Panel>
            ))}
          </Collapse>
        )}
      </Modal>
    </>
  );
};

export default ViewingFormButton;
